module.exports = __webpack_public_path__ + "img/pin.b128128.svg";


//////////////////
// WEBPACK FOOTER
// ./static/images/indicateurs-icons/pin.svg
// module id = oPYM
// module chunks = 7